import { Component,HostBinding, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { mensajeSesionExpiradaService } from 'src/app/services/mensajeSesionExpirada.service';
import Swal from 'sweetalert2';
import { ExcelService } from 'src/app/services/excel.service';
import { InventarioService } from 'src/app/services/inventario.service';

@Component({
  selector: 'app-listadodereportesbecas',
  templateUrl: './listadodereportesbecas.component.html',
  styleUrls: ['./listadodereportesbecas.component.css']
})
export class ListadodereportesbecasComponent implements OnInit {

  becas: any = [];
  becaspagados: any = [];
  resultados: any = [];

  cargo:string;
  plantel:string;
  Nombre:string;

  datos = JSON.parse(localStorage.getItem('datos')!);
  mailusu = this.datos.correop;
  idplantel = this.datos.idplantel;

  // NUEVO
  tipoReporte: string = 'nopagado';
  fechaInicio: any = '';
  fechaFin: any = '';

  
  constructor(
    private inventarioService: InventarioService,
    private msj:mensajeSesionExpiradaService,
    private router:Router,
    private activatedRoute: ActivatedRoute,
    private excelService: ExcelService
  ){
    this.cargo = this.datos.cargodb;
    this.plantel = this.datos.plantel;
    this.Nombre = this.datos.nom;
  }

  ngOnInit(): void {
    this.getBecasCompuExcel();
    this.getBecasPagadoCompuExcel();
  }

  getBecasCompuExcel(){
    this.inventarioService.getListaBecasExcel(this.idplantel).subscribe(
      res => { this.becas = res; },
      err => console.error(err)
    );
  }

  getBecasPagadoCompuExcel(){
    this.inventarioService.getListaBecasExcelpagado(this.idplantel).subscribe(
      res => { this.becaspagados = res; },
      err => console.error(err)
    );
  }

  // NUEVO - FILTRAR SEGÚN LO QUE PIDAS
buscarReportes(){

  // VALIDACIÓN DE FECHAS
  if(!this.fechaInicio || !this.fechaFin){
    Swal.fire({
      icon: 'warning',
      title: 'Faltan fechas',
      text: 'Debes seleccionar fecha de inicio y fecha de fin para realizar la búsqueda.',
      timer: 1800,
      showConfirmButton: false
    });
    return; // DETIENE LA FUNCIÓN
  }

  console.log("Tipo reporte:", this.tipoReporte);
  console.log("Fecha inicio:", this.fechaInicio);
  console.log("Fecha fin:", this.fechaFin);

  let origen = [];

  if(this.tipoReporte === 'nopagado'){
    origen = this.becas;
  }
  else if(this.tipoReporte === 'pagado'){
    origen = this.becaspagados;
  }
  else if(this.tipoReporte === 'todos'){
    origen = [...this.becas, ...this.becaspagados];
  }

  // Filtrar fechas
  const inicio = new Date(this.fechaInicio);
  const fin = new Date(this.fechaFin);

  origen = origen.filter((item: any) => {
    const fecha = new Date(item.fecha_factura || item.fecha_pagonomina);
    return fecha >= inicio && fecha <= fin;
  });

  this.resultados = origen;

  console.log("Registros finales:", this.resultados.length);

}

  // EXPORTAR SEGÚN SELECCIÓN
  exportarExcel(){
    this.excelService.exportAsExcelFile(this.resultados, 'Reporte Becas Filtrado');
  }

}
